import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import { Map } from 'immutable';
import * as types from './Types.js';
import { buildUrl } from './UrlFilter';
import { addPagination } from 'portaltransparencia-common/libs/AddFilter';

const EMPTY_PAGE = Map({});

export function findEmendasMunicipais(filtros, page = EMPTY_PAGE) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/municipais',
    filtros,
    page
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_MUNICIPAIS,
    payload: { promise: fetch(url) }
  });
}

export function findEmendasMunicipaisTotal(filtros) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/municipais/totalizadores',
    filtros
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_MUNICIPAIS_TOTAL,
    payload: { promise: fetch(url) }
  });
}

export function findEmendasFederais(filtros, page = EMPTY_PAGE) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/federais',
    filtros,
    page
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_FEDERAIS,
    payload: { promise: fetch(url) }
  });
}

export function findEmendasFederaisTotal(filtros) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/federais/totalizadores',
    filtros
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_FEDERAIS_TOTAL,
    payload: { promise: fetch(url) }
  });
}

export function findEmendasEstaduais(filtros, page = EMPTY_PAGE) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/estaduais',
    filtros,
    page
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_ESTADUAIS,
    payload: { promise: fetch(url) }
  });
}

export function findEmendasEstaduaisTotal(filtros) {
  const url = buildUrl(
    '/api/emendas-parlamentares/contabilidade/estaduais/totalizadores',
    filtros
  );
  return ({ fetch }) => ({
    type: types.CONSULTA_EMENDAS_ESTADUAIS_TOTAL,
    payload: { promise: fetch(url) }
  });
}

export function findEmendaById(id) {
  return ({ fetch }) => {
    const userInfo = StorageService.getItem('userInfo');
    const { entidade, exercicio } = userInfo;
    return {
      type: types.EMENDA,
      payload: {
        promise: fetch(
          `/api/emendas-parlamentares/contabilidade/${id}?entidade=${entidade.id}&exercicio=${exercicio.id}`
        )
      }
    };
  };
}

export function findMovimentacao(id, page = EMPTY_PAGE) {
  const pagination = addPagination(page);
  const url = `/api/emendas-parlamentares/contabilidade/movimentacao/${id}?${pagination}`;
  return ({ fetch }) => ({
    type: types.EMENDA_MOVIMENTACAO,
    payload: { promise: fetch(url) }
  });
}

export function findTiposTransferencias() {
  return ({ fetch }) => ({
    type: types.TIPO_TRANSFERENCIA,
    payload: {
      promise: fetch(
        '/api/emendas-parlamentares/contabilidade/tipos-transferencias'
      )
    }
  });
}

export function findTiposOrigens() {
  return ({ fetch }) => ({
    type: types.TIPO_ORIGEM,
    payload: {
      promise: fetch('/api/emendas-parlamentares/contabilidade/tipos-origens')
    }
  });
}

export function resetConsulta() {
  return {
    type: types.RESET_CONSULTA_EMENDAS,
    payload: {}
  };
}
